import axios from "axios";
import { clearSession, readToken } from "./session";

if (!axios.__hypertraceConfigured) {
  axios.__hypertraceConfigured = true;

  axios.interceptors.request.use((config) => {
    const url = String(config.url || "");
    const token = readToken();
    if (token && !url.includes("/api/login")) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = String(error?.config?.url || "");
      const isAppApi = url.includes("/api/") && !url.includes("/api/login");
      if (status === 401 && isAppApi) {
        clearSession();
        if (window.location.pathname !== "/") {
          window.location.assign("/");
        }
      }
      return Promise.reject(error);
    }
  );
}

export default axios;
